import { ErrorHandler, Injectable } from '@angular/core';
import { HttpService } from '.';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  private errorsLogged = 0;
  private lastError: string = "";

  constructor(private readonly httpService: HttpService) { }

  handleError(error: any): void {
    if (error.error.exceptionLogged)
      return;

    console.error(error);
    const errorJson = JSON.stringify({
      message: error.message,
      stack: error.stack,
      userAgent: navigator.userAgent
    });

    if (this.errorsLogged >= 100 || errorJson == this.lastError)
      return;

    this.errorsLogged++;
    this.lastError = errorJson;    
    this.httpService.logErrorOnServer(errorJson).subscribe();
  }
}
